import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../theme/Colors";

const Ticker = ({ count }) => {
  return (
    <Box
      sx={{
        zIndex: "99",
        top: "0",
        position: "absolute",
        width: "100%",
        overflow: "hidden",
        backgroundColor: colors.main,
        color: "primary.contrastText",
      }}
    >
      {count >= 0 && (
        <Typography
          variant="body1"
          component="p"
          sx={{
            textAlign: "center",
            padding: "8px 0",
          }}
        >
          Plus que
          <strong style={{ fontSize: "18px" }}>
            <span style={{ backgroundColor: "black", padding: "2px 5px", borderRadius: "6px", margin: "0px 5px" }}> {process.env.REACT_APP_NUMBER_OF_PARTICIPANTS - count} </span>
          </strong>
          places disponibles, Inscrivez-,vous maintenant et tentez votre chance!
        </Typography>
      )}

      {120 - count === 0 && (
        <Typography
          variant="body1"
          component="p"
          sx={{
            textAlign: "center",
            padding: "8px 0px",
          }}
        >
          l'inscription est fermée, essayez la prochaine session, visitez le site web pour connaître la date.
        </Typography>
      )}
    </Box>
  );
};

export default Ticker;
